export var retailer = {
    uid: '',
    roleId: '',
    role: null,
    storeName: '',
    storeWebsite: '',
    storeAddress: '',
    storeCity: '',
    zipcode: '',
    city: '',
    country: '',
    nameTitle: '',
    name: '',
    email: '',
    function: '',
    phoneNumber: '',
    remarks: '',
    isPlanActivated: false
};

export var payment = {
    uid: '',
    planName: '',
    planPrice: '',
    isFreeTrail: false
};

export var registerUser = {
    uid: '',
    roleId: '',
    nameTitle: '',
    name: '',
    email: '',
    doe: null,
    phoneNumber: '',
    profilePhotoPath: '',
    profilePhoto: null,
    cvDocumentPath: '',
    cvDocument: null,
    zipcode: '',
    houseNr: '',
    isPersonOutsideFromNL: false,
    functionOrUniqueSKills: '',
    personalBio: '',
    productLevel: '',
    currentCareerLevel: ''
}

export var socialMediaLink = {
    uid: '',
    twitterLink: '',
    linkedInLink: '',
    facebookLink: '',
    instagramLink: '',
    stackOverFlowLink: '',
    githubLink: ''
}

export var userMetaData = {
    uid: '',
    preferredContract: '',
    hourPerWeek: '',
    maxTravelDistanceFromHome: '',
    maxTravelDistanceFromHomeKm: '',
    availableFrom: '',
    availableFromDate: null,
    email: ''
}

export var userDetails = {
    name: '',
    email: '',
    uid: '',
    userRole: '',
    provider: ''
}
